import Data from "../../../core/data/Data";
import Form from "../../../core/forms/form";
import {storage} from "../../../core/utils/storage";
import {urlEncoder} from "../../../core/utils/url";
import {CURRENCY_CURRENT} from "../../../core/data/global";
import {money} from "../../../core/forms/money";

export const TicketsPurchase = {
    mixins: [storage, urlEncoder, money],
    data: () => ({
        selectedTicketId: null,
        errorMessage: null,
        tickets: new Data({
            url: '/tickets/purchase',
            prefix: 'list'
        }),
        form: new Form({
            'type_id': '',
            'email': '',
            'phone': '',
            'ecocash': '',
            'name': '',
            'surname':'',
            'payment': 'ecocash-usd',
            'delivery': 'sms',
            'message': '',
            'quantity': 1,
        }),
    }),
    computed: {
        ticket() {
            return this.tickets.content.data[0] || {};
        },
        ticketType() {
            const types = this.ticket.types || [];
            return types.find(type => type.id === this.selectedTicketId) || types[0] || {};
        },
        isRsvpTicket() {
            const price = Number(this.ticketType.usd_price);
            return !Number.isNaN(price) && price <= 0;
        },
        ticketTypeInstructions() {
            const instructions = this.ticketType.instructions || [];
            return instructions.filter(instruction => !!instruction)
        },
        ticketTypeFeatures() {
            const features = this.ticketType.features || [];
            return features.filter(feature => !!feature)
        },
        ticketTotal(){
            return this.money(this.form.quantity * (this.form.payment === 'ecocash' ? this.ticketType.zwl_price: this.ticketType.usd_price))
        }
    },
    methods: {
        async getTicketEvent(ticketId) {
            this.tickets.filters.id = ticketId;
            await this.tickets.fetch();
        },
        submit() {
            this.form.errors.clear();
            this.form.type_id = this.ticketType.id
            if (this.isRsvpTicket) {
                this.form.payment = '';
                this.form.ecocash = '';
            }
            this.purchase()
        },
        change(id) {
            this.form.errors.clear();
            this.selectedTicketId = id
        },
        purchase() {
            this.saveToLocalStorage();
            this.errorMessage = null; // Clear any previous error
            return this.form.submit('/tickets/purchase').then(async response => {
                // Redirect based on payment type
                if (response.data.success) {
                    if (response.data.body.payment.payment === "rsvp") {
                        await this.$router.push(`/tickets/complete?id=${response.data.body.payment.ref}`);
                    }

                    if (response.data.body.payment.payment === "ecocash" || response.data.body.payment.payment === "ecocash-usd" ) {
                        await this.$router.push(`/tickets/ecocash?id=${response.data.body.payment.ref}`);
                    }

                    if (response.data.body.payment.payment === "stripe") {
                        window.location.href = response.data.body.payment.url;
                    }
                }
            }).catch(error => {
                if (error.response && error.response.data && error.response.data.errors) {
                    const errors = error.response.data.errors;
                    this.errorMessage = Object.values(errors)[0][0];
                }
            });
        },
    },
    async mounted() {
        this.initStorage([
            'email',
            'phone',
            'ecocash',
            'name',
            'surname',
            'payment',
            'quantity',
        ], 'tickets');

        await this.getTicketEvent(
            this.decode(this.$route.params.id)
        );

        if (this.$route.query.ticket) {
            this.selectedTicketId = this.decode(this.$route.query.ticket)
        }
    }
}
